import React from 'react';
import { FontIconBtn, Tooltip } from '@meitu/saas-ui';
import { useLocaleStore } from '@/i18n';
import './ai-tip.less';

export const AiTip = React.memo(() => {
    const { $t } = useLocaleStore();
    return (
        <Tooltip placement="top" title={$t((v) => v.collapse.moreCollapse.textTool.aiText.tips.disclaimerContent)}>
            <div className="c-ai-tip">
                <FontIconBtn
                    name="QuestionMarkCircleBold"
                    text={$t((v) => v.collapse.moreCollapse.textTool.aiText.tips.disclaimer)}
                    type="button"
                    fontSize={14}
                />
            </div>
        </Tooltip>
    );
});
